import * as React from 'react';
const SvgChevronDown = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 18 12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2.564 0 0 2.676 8.992 12 18 2.676 15.467.032 9 6.785Z" />
  </svg>
);
export default SvgChevronDown;
